import styled from 'styled-components';

const CustomPageIframe = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
  display: flex;
  flex-grow: 1;
`;

export default CustomPageIframe;
